export default "__VITE_ASSET__SKWPMVnH__"